import { render, staticRenderFns } from "./message-v2.vue?vue&type=template&id=cc6215e4"
import script from "./message-v2.vue?vue&type=script&lang=js"
export * from "./message-v2.vue?vue&type=script&lang=js"
import style0 from "./message-v2.vue?vue&type=style&index=0&id=cc6215e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports